web = window.web = window.web || {};
web.credits = window.web.credits = window.web.credits || {};
web.creditsSectionContent = window.web.creditsSectionContent = window.web.creditsSectionContent || {};

var $ = require('jquery');
web.creditsSectionContentSectionContent = require('./SectionContent');

web.creditsSectionContentManager = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.options = $.extend({}, t.defaults, options);

    t.CSS_SELECTOR_PREFIX = null;

    t.SHOW_CLASS = "show";

    t.$context = null;

    t.sectionContentsInstances = [];

    t.activeSectionContentInstance = null;

};

web.creditsSectionContentManager.prototype = {
    init: function(){
        var t = this;

        t.setContext($(t.CSS_SELECTOR_PREFIX+"sectionContents"));
        t._createSectionContentsInstances();
        t._bindEvents();
    },

    setContext: function($context) {
        var t = this;

        t.$context = $context;
    },

    setSelectorPrefix: function(selectorPrefix){
        var t = this;

        t.CSS_SELECTOR_PREFIX = selectorPrefix;
    },

    _bindEvents: function(){
        var t = this;

        $(t.sectionContentsInstances).each(function(i, sectionContentInstance) {

            //$(sectionContentInstance).on("iAmShownNow", function(e) {
            //    $(t).trigger({
            //        type: "visibleSectionContentInstanceSet",
            //        visibleSectionContentInstance: e.iAm,
            //        visibleSectionContentId: e.myId
            //    });
            //});
            //
            //$(sectionContentInstance).on("iAmHiddenNow", function(e) {
            //    $(t).trigger({
            //        type: "invisibleSectionContentInstanceSet",
            //        invisibleSectionContentInstance: e.iAm,
            //        invisibleSectionContentId: e.myId
            //    });
            //})

        });

    },

    unsetAllActiveSectionContents: function(){
        var t = this;

        $(t.sectionContentsInstances).each(function(i, sectionContentInstance) {
            sectionContentInstance.setVisibility(false);
            sectionContentInstance.redraw();
        });
    },

    showSectionContentById: function(id){
        var t = this;

        var sectionContentInstance = t.getSectionContentById(id);

        t._setActiveSectionContent(sectionContentInstance);

    },

    _setActiveSectionContent: function(sectionContentInstance){
        var t = this;
        sectionContentInstance.setVisibility(true);
        sectionContentInstance.redraw();
        t._setActiveSectionContentInstance(sectionContentInstance);
    },

    _createSectionContentsInstances: function(){
        var t = this;

        t._get$sectionContents().each(function(){
            var $this = $(this);

            var sectionContentInstance = new web.creditsSectionContentSectionContent($this);
            sectionContentInstance.setShowClass(t.SHOW_CLASS);
            sectionContentInstance.init();
            t.sectionContentsInstances.push(sectionContentInstance);
        });

    },

    _get$sectionContents: function() {
        var t = this;

        return t.$context.find(t.CSS_SELECTOR_PREFIX+"sectionContent");
    },

    _setActiveSectionContentInstance: function(activeSectionContentInstance){
        var t = this;

        t.activeSectionContentInstance = activeSectionContentInstance;
    },

    getActiveSectionContentInstance: function(){
        var t = this;
        return t.activeSectionContentInstance;
    },

    getSectionContentById: function(id) {
        var t = this;

        var ret = null;
        $(t.sectionContentsInstances).each(function(i, sectionContentInstance) {
            if (sectionContentInstance.getId() == id) {
                ret = sectionContentInstance;
            }
        });

        return ret;

    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/credits/sectionContent/Manager.js